import React from "react";
import downloadFiles from "./DownloadFiles";
import CloudStorage from "../../../CloudStorage/CloudStorage";

export default function DownloadButton({ file }) {
  return (
    <button
      type="button"
      className="download-button  down-top-btn"
      onClick={() => downloadFiles(file?.file)}
    >
      <img
        src={`${CloudStorage.cloudurl}/Assets/Images/common/download-icon-black.png`}
        alt="Download"
      />
    </button>
  );
}
